import React from 'react';
import {useHistory, Redirect} from 'react-router-dom';
import {curry} from 'ramda';

import {getTokenRequest} from '@pluto/rest';
import {baseRoutes} from 'App/AppRouter/routes';
import Login from './Login';

const {stringify} = JSON;

export const handleLogin = curry(async (handlers, response) => {
    const {
        logIn,
        history,
        setNotification,
        getTextEnums,
    } = handlers;
    try {
        const {
            tokenId,
            profileObj,
        } = response;
        const {data} = await getTokenRequest(tokenId);
        const {jwt} = data;
        const {name: userName} = profileObj;
        localStorage.setItem('jwt', jwt);
        localStorage.setItem('userName', userName);
        logIn({
            jwt,
        });
        getTextEnums();

        if (history.action === 'REPLACE' && history.length > 2) {
            return history.goBack();
        }

        return history.push(baseRoutes.landing);
    } catch(error) {
        setNotification({
            type: 'error',
            text: stringify(error.message),
        });
    }
});

export const handleFailure = curry((setNotification, error) => {
    setNotification({
        type: 'error',
        text: stringify(error),
    });
});

export default function LoginContainer(props: any) {
    const {
        logIn,
        setNotification,
        isAuthenticated,
        getTextEnums,
    } = props;
    const history = useHistory();
    const onSuccess = handleLogin({
        logIn,
        history,
        setNotification,
        getTextEnums,
    });
    const onError = handleFailure(setNotification);

    if (isAuthenticated) {
        return <Redirect to={baseRoutes.landing} />;
    }

    return (
        <Login
            onSuccess={onSuccess}
            onFailure={onError}
        />
    );
}
